export default "__VITE_ASSET__IiYsR76N__"